/* Native five-step Style Profile onboarding. Public dictionaries supply the
   choices. The only writes are the authenticated owner's avatar and final
   profile upsert, both reserved for the consolidated founder test. */

(function () {
  'use strict';

  var SESSION_KEY = 'gettmi:session:v1';
  var MAX_CREATORS = 10;
  var FALLBACK_STYLES = [
    { key: 'dresses', label: 'Dresses', value: 'Dresses' },
    { key: 'night_out', label: 'Night Out', value: 'Night Out' },
    { key: 'holiday', label: 'Holiday', value: 'Holiday' },
    { key: 'new_in', label: 'Just Dropped', value: 'New In' },
    { key: 'accessories', label: 'Accessories', value: 'Accessories' },
    { key: 'most_wanted', label: 'Most Wanted', value: 'Most Wanted' },
    { key: 'clothing', label: 'Clothing', value: 'Clothing' },
    { key: 'shoes', label: 'Shoes', value: 'Shoes' }
  ];
  var FALLBACK_CREATORS = [
    { id: 'sheeeeoo', name: 'Sheeeeoo', handle: '@Sheeeeoo', vibe: 'Occasion dressing', aliases: [], avatar: '', featured: true },
    { id: 'lynnkelly', name: 'Lynn Kelly', handle: '@Lynnkelly_', vibe: 'Trend edits', aliases: [], avatar: '', featured: true },
    { id: 'cocobeautea', name: 'Coco Beautea', handle: '@cocobeautea', vibe: 'Soft glam', aliases: [], avatar: '', featured: true },
    { id: 'dcopperman', name: 'Dani Copperman', handle: '@dcopperman', vibe: 'City polish', aliases: [], avatar: '', featured: true },
    { id: 'fusunlinder', name: 'Fusun Linder', handle: '@FusunLinder', vibe: 'Elevated classics', aliases: [], avatar: '', featured: true }
  ];
  var state = freshState();

  function freshState() {
    return {
      creatorMode: 'az',
      creatorQuery: '',
      creators: FALLBACK_CREATORS.slice(),
      dateOfBirth: '',
      firstName: '',
      lastName: '',
      loadId: 0,
      nameLocked: false,
      openingFeed: ['Dresses', 'Night Out'],
      photoUrl: '',
      selectedCreators: [],
      session: null,
      styles: FALLBACK_STYLES.slice(),
      suggestedCreators: [],
      username: ''
    };
  }

  function settingsRoot() {
    return document.querySelector('[data-gettmi-settings]');
  }

  function config() {
    var node = document.querySelector('[data-gettmi-supabase]');
    return node ? { url: node.dataset.supabaseUrl, key: node.dataset.supabaseKey } : null;
  }

  function storedSession() {
    try {
      return JSON.parse(window.localStorage.getItem(SESSION_KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function currentSession() {
    return state.session || storedSession();
  }

  function authHeaders(extra) {
    var cfg = config();
    var session = currentSession();
    return Object.assign({
      apikey: cfg.key,
      Authorization: 'Bearer ' + session.access_token
    }, extra || {});
  }

  function el(tag, className, textValue) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (typeof textValue !== 'undefined') node.textContent = textValue;
    return node;
  }

  function asArray(value) {
    return Array.isArray(value) ? value.filter(Boolean) : [];
  }

  function cleanName(value) {
    return String(value || '').replace(/[^a-zA-Z '-]/g, '').trim();
  }

  function showStep(step) {
    var root = settingsRoot();
    if (!root) return;
    root.querySelectorAll('[data-gettmi-auth-step]').forEach(function (section) {
      section.hidden = section.dataset.gettmiAuthStep !== 'onboarding-' + step;
    });
    var active = root.querySelector('[data-gettmi-auth-step="onboarding-' + step + '"]');
    if (active) {
      var scroll = active.querySelector('.gettmi-onboarding__creator-scroll');
      if (scroll) scroll.scrollTop = 0;
    }
  }

  function setError(selector, message) {
    var root = settingsRoot();
    var node = root && root.querySelector(selector);
    if (!node) return;
    node.textContent = message || '';
    node.hidden = !message;
  }

  function usernameOptions() {
    var first = state.firstName.toLowerCase().replace(/[^a-z0-9]/g, '');
    var last = state.lastName.toLowerCase().replace(/[^a-z0-9]/g, '');
    if (!first || !last) return [];
    var base = first + last;
    return [
      base,
      first + last.charAt(0),
      first.charAt(0) + last,
      base + '1',
      base + '2',
      first + last.slice(0, 2)
    ].filter(function (value, index, values) {
      return value && values.indexOf(value) === index;
    }).slice(0, 3);
  }

  function renderUsernames() {
    var root = settingsRoot();
    var block = root && root.querySelector('[data-gettmi-onboarding-username-block]');
    var mount = root && root.querySelector('[data-gettmi-onboarding-usernames]');
    if (!block || !mount) return;
    mount.replaceChildren();
    usernameOptions().forEach(function (option) {
      var button = el('button', state.username === option ? 'is-active' : '', '@' + option);
      button.type = 'button';
      button.dataset.gettmiOnboardingUsername = option;
      mount.appendChild(button);
    });
    block.hidden = !state.nameLocked;
  }

  function renderStyles() {
    var root = settingsRoot();
    var mount = root && root.querySelector('[data-gettmi-onboarding-style-choices]');
    if (!mount) return;
    mount.replaceChildren();
    state.styles.forEach(function (choice) {
      var button = el('button', state.openingFeed.indexOf(choice.value) !== -1 ? 'is-active' : '', choice.label);
      button.type = 'button';
      button.dataset.gettmiOnboardingStyle = choice.value;
      mount.appendChild(button);
    });
  }

  function creatorMatches(creator, query) {
    if (!query) return true;
    return [creator.name, creator.handle, creator.vibe].concat(creator.aliases || [])
      .filter(Boolean).join(' ').toLowerCase().indexOf(query) !== -1;
  }

  function creatorAvatar(creator) {
    var avatar = el('span', 'gettmi-onboarding__creator-avatar');
    if (creator.avatar) {
      var image = document.createElement('img');
      image.src = creator.avatar;
      image.alt = '';
      image.width = 56;
      image.height = 56;
      image.loading = 'lazy';
      avatar.appendChild(image);
    } else {
      avatar.appendChild(el('b', '', String(creator.name || 'G').charAt(0).toUpperCase()));
    }
    return avatar;
  }

  function creatorButton(creator, featured) {
    var active = state.selectedCreators.indexOf(creator.id) !== -1;
    var button = el('button', 'gettmi-onboarding__creator-card' + (featured ? ' is-featured' : '') + (active ? ' is-active' : ''));
    button.type = 'button';
    button.dataset.gettmiOnboardingCreator = creator.id;
    button.appendChild(creatorAvatar(creator));
    var copy = el('span');
    copy.appendChild(el('strong', '', creator.name));
    copy.appendChild(el('small', '', creator.handle + (!featured && creator.vibe ? ' · ' + creator.vibe : '')));
    button.appendChild(copy);
    button.appendChild(el('i', '', active ? '✓' : '♥'));
    return button;
  }

  function renderSelectedCreators() {
    var root = settingsRoot();
    if (!root) return;
    var selected = root.querySelector('[data-gettmi-onboarding-selected-creators]');
    var suggested = root.querySelector('[data-gettmi-onboarding-suggested-creators]');
    selected.replaceChildren();
    state.selectedCreators.forEach(function (id) {
      var creator = state.creators.find(function (choice) { return choice.id === id; });
      if (!creator) return;
      var button = el('button', '', creator.handle + ' ×');
      button.type = 'button';
      button.dataset.gettmiOnboardingCreator = id;
      selected.appendChild(button);
    });
    selected.hidden = !selected.children.length;
    suggested.replaceChildren();
    state.suggestedCreators.forEach(function (handle) {
      var button = el('button', '', 'Suggested ' + handle + ' ×');
      button.type = 'button';
      button.dataset.gettmiOnboardingRemoveSuggestion = handle;
      suggested.appendChild(button);
    });
    suggested.hidden = !suggested.children.length;
    root.querySelector('[data-gettmi-onboarding-creator-limit]').textContent =
      state.selectedCreators.length + '/' + MAX_CREATORS + ' selected';
  }

  function renderFeaturedCreators(choices) {
    var root = settingsRoot();
    var mount = root && root.querySelector('[data-gettmi-onboarding-featured-creators]');
    if (!mount) return;
    mount.replaceChildren();
    if (state.creatorQuery) {
      mount.hidden = true;
      return;
    }
    var featured = choices.filter(function (creator) { return creator.featured; }).slice(0, 10);
    if (!featured.length) {
      mount.hidden = true;
      return;
    }
    mount.hidden = false;
    mount.appendChild(el('h3', '', 'Trending creators'));
    var rail = el('div', 'gettmi-onboarding__creator-rail');
    featured.forEach(function (creator) {
      rail.appendChild(creatorButton(creator, true));
    });
    mount.appendChild(rail);
  }

  function renderCreatorDirectory(choices) {
    var root = settingsRoot();
    var list = root && root.querySelector('[data-gettmi-onboarding-creator-list]');
    var modes = root && root.querySelector('.gettmi-onboarding__creator-modes');
    if (!list || !modes) return;
    list.replaceChildren();
    modes.hidden = Boolean(state.creatorQuery);
    var available = choices.filter(function (creator) {
      return state.selectedCreators.indexOf(creator.id) === -1;
    });
    var groups = {};
    available.forEach(function (creator) {
      var key = state.creatorMode === 'category'
        ? (creator.vibe || 'Style creators')
        : String(creator.name || '#').charAt(0).toUpperCase();
      if (!groups[key]) groups[key] = [];
      groups[key].push(creator);
    });
    Object.keys(groups).sort(function (a, b) { return a.localeCompare(b); }).forEach(function (key) {
      var section = document.createElement('section');
      section.appendChild(el('h3', '', key));
      groups[key].forEach(function (creator) {
        section.appendChild(creatorButton(creator, false));
      });
      list.appendChild(section);
    });
    if (!available.length) {
      list.appendChild(el('p', 'gettmi-onboarding__creator-empty', state.creatorQuery ? 'No creators found yet.' : 'No creators available yet.'));
    }
  }

  function renderCreatorSuggestion(choices) {
    var root = settingsRoot();
    var button = root && root.querySelector('[data-gettmi-onboarding-suggest]');
    if (!button) return;
    var raw = state.creatorQuery.trim();
    var handle = raw ? (raw.charAt(0) === '@' ? raw : '@' + raw) : '';
    var exact = choices.some(function (creator) {
      return String(creator.handle || '').toLowerCase() === handle.toLowerCase();
    });
    button.hidden = !handle || exact || state.suggestedCreators.indexOf(handle) !== -1;
    button.textContent = handle ? 'Suggest ' + handle : '';
    button.dataset.gettmiOnboardingSuggest = handle;
  }

  function renderCreators() {
    var root = settingsRoot();
    if (!root) return;
    var query = state.creatorQuery.trim().toLowerCase();
    var choices = state.creators.filter(function (creator) {
      return creatorMatches(creator, query);
    });
    renderSelectedCreators();
    renderFeaturedCreators(choices);
    renderCreatorDirectory(choices);
    renderCreatorSuggestion(choices);
    root.querySelectorAll('[data-gettmi-onboarding-creator-mode]').forEach(function (button) {
      button.classList.toggle('is-active', button.dataset.gettmiOnboardingCreatorMode === state.creatorMode);
    });
  }

  function loadPublicData() {
    var cfg = config();
    if (!cfg || !cfg.url || !cfg.key) return;
    state.loadId += 1;
    var loadId = state.loadId;
    var headers = { apikey: cfg.key, Authorization: 'Bearer ' + cfg.key };
    var stylesRequest = window.fetch(
      cfg.url + '/rest/v1/style_profile_options?' +
        'select=dimension,option_key,profile_value,label,sort_order' +
        '&dimension=eq.opening_feed&order=sort_order.asc',
      { headers: headers }
    ).then(function (response) {
      return response.ok ? response.json() : [];
    });
    var creatorsRequest = window.fetch(
      cfg.url + '/rest/v1/creator_directory?' +
        'select=creator_id,display_name,handle,avatar_url,vibe,search_aliases,sort_order,is_featured' +
        '&status=eq.active&order=is_featured.desc,sort_order.asc,display_name.asc',
      { headers: headers }
    ).then(function (response) {
      return response.ok ? response.json() : [];
    });
    Promise.all([stylesRequest, creatorsRequest]).then(function (results) {
      if (loadId !== state.loadId) return;
      if (results[0].length) {
        state.styles = results[0].map(function (row) {
          return { key: row.option_key, label: row.label, value: row.profile_value };
        });
      }
      if (results[1].length) {
        state.creators = results[1].map(function (row) {
          return {
            aliases: asArray(row.search_aliases),
            avatar: row.avatar_url || '',
            featured: Boolean(row.is_featured),
            handle: row.handle || '',
            id: row.creator_id,
            name: row.display_name || row.handle || '',
            vibe: row.vibe || ''
          };
        }).filter(function (creator) {
          return creator.id && creator.name && creator.handle;
        });
      }
      renderStyles();
      renderCreators();
    }).catch(function () {
      /* Complete bundled options stay visible if the public dictionaries fail. */
    });
  }

  function seedIdentity() {
    var cfg = config();
    var session = currentSession();
    if (!cfg || !session || !session.access_token) return;
    window.fetch(cfg.url + '/auth/v1/user', {
      headers: { apikey: cfg.key, Authorization: 'Bearer ' + session.access_token }
    }).then(function (response) {
      return response.ok ? response.json() : null;
    }).then(function (user) {
      if (!user || state.nameLocked) return;
      var meta = user.user_metadata || {};
      var full = String(meta.full_name || meta.name || '').trim().split(/\s+/);
      state.firstName = cleanName(meta.first_name || meta.given_name || full[0] || '');
      state.lastName = cleanName(meta.last_name || meta.family_name || full.slice(1).join(' ') || '');
      var root = settingsRoot();
      if (!root) return;
      root.querySelector('[data-gettmi-onboarding-first-name]').value = state.firstName;
      root.querySelector('[data-gettmi-onboarding-last-name]').value = state.lastName;
    }).catch(function () {
      /* Manual name entry remains available. */
    });
  }

  function resetUi() {
    var root = settingsRoot();
    if (!root) return;
    root.querySelector('[data-gettmi-onboarding-first-name]').value = '';
    root.querySelector('[data-gettmi-onboarding-last-name]').value = '';
    root.querySelectorAll('[data-gettmi-onboarding-dob]').forEach(function (input) {
      input.value = '';
      input.classList.remove('is-error');
    });
    root.querySelector('[data-gettmi-onboarding-creator-query]').value = '';
    root.querySelector('[data-gettmi-onboarding-username-block]').hidden = true;
    var photo = root.querySelector('[data-gettmi-onboarding-photo]');
    photo.removeAttribute('src');
    photo.hidden = true;
    root.querySelector('[data-gettmi-onboarding-photo-initial]').hidden = false;
    root.querySelector('[data-gettmi-onboarding-photo-preview]').classList.remove('is-active');
    root.querySelector('[data-gettmi-onboarding-photo-button]').textContent = 'Add photo';
    root.querySelector('[data-gettmi-onboarding-photo-status]').textContent =
      'Make your Gettmi profile feel like you. You can update it later.';
    setError('[data-gettmi-onboarding-name-error]', '');
    setError('[data-gettmi-onboarding-dob-error]', '');
    setError('[data-gettmi-onboarding-creators-error]', '');
    setError('[data-gettmi-onboarding-save-error]', '');
  }

  function startOnboarding(session) {
    var next = freshState();
    next.session = session || storedSession();
    next.loadId = state.loadId + 1;
    state = next;
    resetUi();
    renderStyles();
    renderCreators();
    showStep('name');
    loadPublicData();
    seedIdentity();
  }

  function continueName() {
    var root = settingsRoot();
    state.firstName = cleanName(root.querySelector('[data-gettmi-onboarding-first-name]').value);
    state.lastName = cleanName(root.querySelector('[data-gettmi-onboarding-last-name]').value);
    if (!state.firstName || !state.lastName) {
      setError(
        '[data-gettmi-onboarding-name-error]',
        !state.firstName && !state.lastName
          ? 'Enter your first and last name.'
          : (!state.firstName ? 'Enter your first name.' : 'Enter your last name.')
      );
      return;
    }
    setError('[data-gettmi-onboarding-name-error]', '');
    if (!state.nameLocked) {
      state.nameLocked = true;
      state.username = usernameOptions()[0] || '';
      renderUsernames();
      return;
    }
    if (!state.username) {
      root.querySelector('[data-gettmi-onboarding-username-error]').hidden = false;
      return;
    }
    showStep('dob');
  }

  function calculateDob() {
    var root = settingsRoot();
    var dayText = root.querySelector('[data-gettmi-onboarding-dob="day"]').value.trim();
    var monthText = root.querySelector('[data-gettmi-onboarding-dob="month"]').value.trim();
    var yearText = root.querySelector('[data-gettmi-onboarding-dob="year"]').value.trim();
    var day = /^\d+$/.test(dayText) ? Number(dayText) : null;
    var month = /^\d+$/.test(monthText) ? Number(monthText) : null;
    var year = /^\d+$/.test(yearText) ? Number(yearText) : null;
    if (day === null || month === null || year === null) {
      return { error: 'Enter your full date of birth.' };
    }
    var now = new Date();
    var candidate = new Date(year, month - 1, day);
    var real = yearText.length === 4 &&
      candidate.getFullYear() === year &&
      candidate.getMonth() === month - 1 &&
      candidate.getDate() === day &&
      candidate.getTime() <= now.getTime();
    if (!real) return { error: 'That date does not look right. Please check it.' };
    var age = now.getFullYear() - year;
    if (now.getMonth() + 1 < month || (now.getMonth() + 1 === month && now.getDate() < day)) age -= 1;
    if (age > 120) return { error: 'That date does not look right. Please check it.' };
    if (age < 13) return { error: 'You need to be at least 13 to use Gettmi.' };
    return {
      iso: year + '-' + String(month).padStart(2, '0') + '-' + String(day).padStart(2, '0')
    };
  }

  function continueDob() {
    var result = calculateDob();
    var root = settingsRoot();
    root.querySelectorAll('[data-gettmi-onboarding-dob]').forEach(function (input) {
      input.classList.toggle('is-error', Boolean(result.error));
    });
    if (result.error) {
      setError('[data-gettmi-onboarding-dob-error]', result.error);
      return;
    }
    state.dateOfBirth = result.iso;
    setError('[data-gettmi-onboarding-dob-error]', '');
    showStep('style');
  }

  function toggleCreator(id) {
    if (state.selectedCreators.indexOf(id) !== -1) {
      state.selectedCreators = state.selectedCreators.filter(function (creatorId) {
        return creatorId !== id;
      });
    } else if (state.selectedCreators.length < MAX_CREATORS) {
      state.selectedCreators = state.selectedCreators.concat(id);
    }
    setError('[data-gettmi-onboarding-creators-error]', '');
    renderCreators();
  }

  function showPhotoStep() {
    if (!state.selectedCreators.length) {
      setError('[data-gettmi-onboarding-creators-error]', 'Choose at least one creator to continue.');
      return;
    }
    var root = settingsRoot();
    var initial = String(state.username || state.firstName || 'G').charAt(0).toUpperCase();
    root.querySelector('[data-gettmi-onboarding-photo-initial]').textContent = initial;
    showStep('photo');
  }

  function showReady() {
    showStep('ready');
    var ready = settingsRoot().querySelector('[data-gettmi-auth-step="onboarding-ready"]');
    ready.classList.remove('is-animating');
    window.requestAnimationFrame(function () {
      ready.classList.add('is-animating');
    });
  }

  function uploadPhoto(file) {
    var cfg = config();
    var session = currentSession();
    var root = settingsRoot();
    var status = root && root.querySelector('[data-gettmi-onboarding-photo-status]');
    var image = root && root.querySelector('[data-gettmi-onboarding-photo]');
    var initial = root && root.querySelector('[data-gettmi-onboarding-photo-initial]');
    var preview = root && root.querySelector('[data-gettmi-onboarding-photo-preview]');
    if (!cfg || !session || !session.user_id || !file || !status || !image) return;
    if (file.size > 5 * 1024 * 1024) {
      status.textContent = 'Choose a photo under 5MB.';
      return;
    }
    var extension = file.type === 'image/png' ? 'png' : file.type === 'image/webp' ? 'webp' : 'jpg';
    var path = session.user_id + '/avatar.' + extension;
    var localUrl = URL.createObjectURL(file);
    image.src = localUrl;
    image.hidden = false;
    initial.hidden = true;
    preview.classList.add('is-active');
    status.textContent = 'Uploading photo…';
    window.fetch(cfg.url + '/storage/v1/object/avatars/' + path, {
      method: 'POST',
      headers: authHeaders({
        'Content-Type': file.type || 'image/jpeg',
        'x-upsert': 'true'
      }),
      body: file
    }).then(function (response) {
      if (!response.ok) throw new Error();
      state.photoUrl = cfg.url + '/storage/v1/object/public/avatars/' + path + '?v=' + Date.now();
      image.src = state.photoUrl;
      status.textContent = 'Photo added';
      root.querySelector('[data-gettmi-onboarding-photo-button]').textContent = 'Update photo';
    }).catch(function () {
      state.photoUrl = '';
      image.removeAttribute('src');
      image.hidden = true;
      initial.hidden = false;
      preview.classList.remove('is-active');
      status.textContent = 'We couldn’t upload that photo. Please check your connection and try again.';
    }).finally(function () {
      URL.revokeObjectURL(localUrl);
    });
  }

  function completeOnboarding() {
    var cfg = config();
    var session = currentSession();
    var root = settingsRoot();
    var button = root && root.querySelector('[data-gettmi-onboarding-complete]');
    if (!cfg || !session || !session.user_id || !button) {
      setError('[data-gettmi-onboarding-save-error]', 'Please verify your email before entering Gettmi.');
      return;
    }
    var payload = {
      date_of_birth: state.dateOfBirth,
      email: session.email || '',
      favourite_creator_ids: state.selectedCreators,
      first_name: state.firstName,
      id: session.user_id,
      last_name: state.lastName,
      opening_feed: state.openingFeed,
      profile_photo_url: state.photoUrl || null,
      style_profile_ready: true,
      suggested_creator_handles: state.suggestedCreators,
      updated_at: new Date().toISOString(),
      username: state.username
    };
    button.disabled = true;
    button.textContent = 'Saving...';
    setError('[data-gettmi-onboarding-save-error]', '');
    window.fetch(cfg.url + '/rest/v1/profiles?on_conflict=id', {
      method: 'POST',
      headers: authHeaders({
        'Content-Type': 'application/json',
        Prefer: 'resolution=merge-duplicates,return=representation'
      }),
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error();
      return response.json();
    }).then(function (rows) {
      document.dispatchEvent(new CustomEvent('gettmi:onboarding-complete', {
        detail: { profile: rows && rows[0] ? rows[0] : payload, session: session }
      }));
    }).catch(function () {
      setError('[data-gettmi-onboarding-save-error]', 'Could not save your profile. Please try again.');
    }).finally(function () {
      button.disabled = false;
      button.textContent = 'Enter Gettmi';
    });
  }

  document.addEventListener('gettmi:onboarding-required', function (event) {
    startOnboarding(event.detail && event.detail.session);
  });

  document.addEventListener('gettmi:signed-out', function () {
    state.loadId += 1;
    state = freshState();
    resetUi();
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest('[data-gettmi-auth-step^="onboarding-"]')) return;
    if (target.closest('[data-gettmi-onboarding-cancel]')) {
      document.dispatchEvent(new CustomEvent('gettmi:onboarding-cancel'));
      return;
    }
    var back = target.closest('[data-gettmi-onboarding-back]');
    if (back) {
      showStep(back.dataset.gettmiOnboardingBack);
      return;
    }
    var username = target.closest('[data-gettmi-onboarding-username]');
    if (username) {
      state.username = username.dataset.gettmiOnboardingUsername;
      settingsRoot().querySelector('[data-gettmi-onboarding-username-error]').hidden = true;
      renderUsernames();
      return;
    }
    var style = target.closest('[data-gettmi-onboarding-style]');
    if (style) {
      var value = style.dataset.gettmiOnboardingStyle;
      state.openingFeed = state.openingFeed.indexOf(value) !== -1
        ? state.openingFeed.filter(function (item) { return item !== value; })
        : state.openingFeed.concat(value);
      style.classList.toggle('is-active', state.openingFeed.indexOf(value) !== -1);
      return;
    }
    var creator = target.closest('[data-gettmi-onboarding-creator]');
    if (creator) {
      toggleCreator(creator.dataset.gettmiOnboardingCreator);
      return;
    }
    var removeSuggestion = target.closest('[data-gettmi-onboarding-remove-suggestion]');
    if (removeSuggestion) {
      state.suggestedCreators = state.suggestedCreators.filter(function (handle) {
        return handle !== removeSuggestion.dataset.gettmiOnboardingRemoveSuggestion;
      });
      renderCreators();
      return;
    }
    var mode = target.closest('[data-gettmi-onboarding-creator-mode]');
    if (mode) {
      state.creatorMode = mode.dataset.gettmiOnboardingCreatorMode;
      renderCreators();
      return;
    }
    var suggest = target.closest('[data-gettmi-onboarding-suggest]');
    if (suggest) {
      var handle = suggest.dataset.gettmiOnboardingSuggest;
      if (handle && state.suggestedCreators.indexOf(handle) === -1) {
        state.suggestedCreators = state.suggestedCreators.concat(handle);
        state.creatorQuery = '';
        settingsRoot().querySelector('[data-gettmi-onboarding-creator-query]').value = '';
        renderCreators();
      }
      return;
    }
    if (target.closest('[data-gettmi-onboarding-photo-button]')) {
      settingsRoot().querySelector('[data-gettmi-onboarding-photo-input]').click();
      return;
    }
    if (target.closest('[data-gettmi-onboarding-skip-photo]')) {
      showReady();
      return;
    }
    var next = target.closest('[data-gettmi-onboarding-continue]');
    if (next) {
      var step = next.dataset.gettmiOnboardingContinue;
      if (step === 'name') continueName();
      else if (step === 'dob') continueDob();
      else if (step === 'style') showStep('creators');
      else if (step === 'creators') showPhotoStep();
      else if (step === 'photo') showReady();
      return;
    }
    if (target.closest('[data-gettmi-onboarding-complete]')) completeOnboarding();
  });

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (input.matches('[data-gettmi-onboarding-first-name], [data-gettmi-onboarding-last-name]')) {
      state.nameLocked = false;
      state.username = '';
      settingsRoot().querySelector('[data-gettmi-onboarding-username-block]').hidden = true;
      setError('[data-gettmi-onboarding-name-error]', '');
      return;
    }
    if (input.matches('[data-gettmi-onboarding-dob]')) {
      input.value = input.value.replace(/\D/g, '');
      setError('[data-gettmi-onboarding-dob-error]', '');
      input.classList.remove('is-error');
      if (input.dataset.gettmiOnboardingDob === 'day' && input.value.length === 2) {
        settingsRoot().querySelector('[data-gettmi-onboarding-dob="month"]').focus();
      } else if (input.dataset.gettmiOnboardingDob === 'month' && input.value.length === 2) {
        settingsRoot().querySelector('[data-gettmi-onboarding-dob="year"]').focus();
      }
      return;
    }
    if (input.matches('[data-gettmi-onboarding-creator-query]')) {
      state.creatorQuery = input.value;
      renderCreators();
    }
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-gettmi-onboarding-photo-input]')) return;
    var file = event.target.files && event.target.files[0];
    if (file) uploadPhoto(file);
    event.target.value = '';
  });
})();
